import script from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=05680470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05680470"]])

export default __exports__